import React from "react";
import { Checkbox, Col, Form, Input, Row } from "antd";
import {financialIRM, medicalIRM, psychologicalIRM} from "../../../constants/irm.constant";
export default function IndividualIRMPackage() {
    return (
        <>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={4}>
                    <Form.Item
                        label="Financial IRM"
                        name="financialIRM"
                        rules={[{required: true, message: 'Please select at least one option!'}]}
                    >
                        <Checkbox.Group style={{flexDirection: 'column', paddingLeft: '10px'}}>
                            {financialIRM.map((item, index) => <Checkbox key={index}
                                                                         value={item.key}>{item.value}</Checkbox>)}
                        </Checkbox.Group>
                    </Form.Item>
                </Col>
                <Col xs={24} xl={20}>
                    <Form.Item
                        name="financialIRMDetails"
                        label="Details of selected measures"
                        rules={[
                            {
                                required: false,
                                message: "please specify",
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} placeholder="Enter your answers here"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={4}>
                    <Form.Item
                        label="Psychological IRM"
                        name="psychologicalIRM"
                        rules={[{required: true, message: 'Please select at least one option!'}]}
                    >
                        <Checkbox.Group style={{flexDirection: 'column', paddingLeft: '10px'}}>
                            {psychologicalIRM.map((item, index) => <Checkbox key={index}
                                                                             value={item.key}>{item.value}</Checkbox>)}
                        </Checkbox.Group>
                    </Form.Item>
                </Col>
                <Col xs={24} xl={20}>
                    <Form.Item
                        name="psychologicalIRMDetails"
                        label="Details of selected measures"
                        rules={[
                            {
                                required: false,
                                message: "please specify",
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} placeholder="Enter your answers here"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={4}>
                    <Form.Item
                        label="Medical IRM"
                        name="medicalIRM"
                        rules={[{required: true, message: 'Please select at least one option!'}]}
                    >
                        <Checkbox.Group style={{flexDirection: 'column', paddingLeft: '10px'}}>
                            {medicalIRM.map((item, index) => <Checkbox key={index}
                                                                       value={item.key}>{item.value}</Checkbox>)}
                        </Checkbox.Group>
                    </Form.Item>
                </Col>
                <Col xs={24} xl={20}>
                    <Form.Item
                        name="medicalIRMDetails"
                        label="Details of selected measures"
                        rules={[
                            {
                                required: false,
                                message: "please specify",
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} placeholder="Enter your answers here"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={24}>
                    <Form.Item
                        name="accompaniment"
                        label="Please indicate any personal preferences in terms of accompaniment (for example, if you
prefer to meet case workers outside your home):"
                        rules={[
                            {
                                required: true,
                                message: "please specify",
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} placeholder="Enter your answers here"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={24}>
                    <Form.Item
                        name="closingTheInterview"
                        label="Is there anything you would like to add, before we end the interview?"
                        rules={[
                            {
                                required: true,
                                message: "please specify",
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} placeholder="Enter your answers here"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={24}>
                    <Form.Item
                        name="place"
                        label={"Place"}
                        rules={[{required: true, message: "Please specify"}]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
}
